module.exports = __webpack_public_path__ + "img/sec12mob.d2bc653c.png";